import TextField from './TextField/'
import FileInput from './FileInput/'
import DatePicker from './DatePicker/'
import DateRangePicker from './DateRangePicker/'
import DataTable from './DataTable/'
import DataTableLink from './DataTableLink/'
import TextArea from './TextArea/'
import TelInput from './TelInput/'
import NumberField from './NumberField/'
import Select from './Select/'
import Label from './Label/'
import ComputedField from './special-inputs/ComputeField'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import ColorPicker from './ColorPicker'
import SlashTextField from './special-inputs/SlashTextField'
import Uploader from './Uploader'
import MonthPicker from './special-inputs/MonthPicker'
import OptionGroup from './OptionGroup'
import WYSIWYG from './WYSIWYG'
import List from './List'
import Slider from './Slider'
import Checkbox from './Checkbox'
import Toggle from './Toggle'

export default {
  TextField,
  DatePicker,
  TextArea,
  NumberField,
  Label,
  DataTable,
  DataTableLink,
  ValidationObserver,
  ValidationProvider,
  Select,
  ComputedField,
  TelInput,
  ColorPicker,
  DateRangePicker,
  SlashTextField,
  Uploader,
  FileInput,
  MonthPicker,
  OptionGroup,
  WYSIWYG,
  List,
  Slider,
  Checkbox,
  Toggle
}
